import React from 'react';
import { TextInput } from '@youngcapital/component-library';
import { FIELDSET_PROPTYPES } from '../asFieldset';
import { urlHandler } from './helpers';

const LinkedInUrlComponent = ({ getFieldProps, t }) => {
  const LinkedinField = 'linkedin_profile_link';
  const LinkedInUrlComponentProps = getFieldProps(LinkedinField);

  const handleBlur = event => {
    const url = event.target.value;
    const validatedUrl = urlHandler(url);

    getFieldProps(LinkedinField).setValue(validatedUrl);
    return LinkedInUrlComponentProps.onBlur(event);
  };
  return (
    <div className='mb-4x'>
      <hr />
      <TextInput
        {...getFieldProps('linkedin_profile_link')}
        onBlur={handleBlur}
        type='text'
        label={t('cv_fieldset.add_linkedin_url')}
      />
    </div>
  );
};

LinkedInUrlComponent.propTypes = FIELDSET_PROPTYPES;

export default LinkedInUrlComponent;
